import SectionHeading from "../components/SectionHeading";
import { activities } from "../data/activities";
import "./Activities.css";

export default function Activities() {
  return (
    <section id="activities" className="section section--blue">
      <div className="container">

        <SectionHeading plain="Our" accent="Activities">
          
        </SectionHeading>

        <div className="activities">

          {activities.map((category) => (
            <div
              className="activity-category"
              key={category.title}
            >

              <h2 className="activity-category__title">
                {category.title}
              </h2>

              <div className="activity-category__grid">

                {category.items.map((item) => (
                  <div
                    className="activity"
                    key={item.src}
                  >

                    {item.type === "image" ? (
                      <img
                        src={item.src}
                        alt={item.alt}
                        loading="lazy"
                      />
                    ) : (
                      <video
                        src={item.src}
                        controls
                        preload="metadata"
                        playsInline
                      />
                    )}

                  </div>
                ))}

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}